



































import {
  Vue,
  Component
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import BeneficiaryTable from "@/employee/components/settings/BeneficiaryTable.vue";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { Beneficiary, BeneficiaryStatus, BeneficiaryType } from "@/shared/types";
@Component({
  components: {
    GenericLoadingSpinner,
    BeneficiaryTable
  }
})

export default class Beneficiaries extends Vue {
    bankAccountStore = useBankAccountStore();

    mounted (): void {
        this.bankAccountStore.loadBeneficiaries();
    }

    get isLoaded (): boolean {
      return this.bankAccountStore.isBeneficiariesLoaded;
    }

    get showBeneficiaries (): boolean {
      return this.beneficiaries && this.beneficiaries.length > 0;
    }

    get beneficiaries (): Beneficiary[] {
      return this.bankAccountStore.beneficiaries;
    }

    get activeBeneficiaries (): Beneficiary[] {
      return this.beneficiaries.filter(x => x.status === BeneficiaryStatus.Active);
    }

    get activePrimaryBeneficiaries (): Beneficiary[] {
      return this.activeBeneficiaries.filter(x => x.type === BeneficiaryType.Primary);
    }

    get activeContingentBeneficiaries (): Beneficiary[] {
      return this.activeBeneficiaries.filter(x => x.type === BeneficiaryType.Contingent);
    }

    get inactiveBeneficiaries (): Beneficiary[] {
      return this.beneficiaries.filter(x => x.status === BeneficiaryStatus.Inactive);
    }

    get inactivePrimaryBeneficiaries (): Beneficiary[] {
      return this.inactiveBeneficiaries.filter(x => x.type === BeneficiaryType.Primary);
    }

    get inactiveContingentBeneficiaries (): Beneficiary[] {
      return this.inactiveBeneficiaries.filter(x => x.type === BeneficiaryType.Contingent);
    }

    get hasActiveBeneficiaries (): boolean {
      return this.activeBeneficiaries && this.activeBeneficiaries.length > 0;
    }

    get hasActiveContingentBeneficiaries (): boolean {
      return this.activeContingentBeneficiaries && this.activeContingentBeneficiaries.length > 0;
    }

    get hasInactiveBeneficiaries (): boolean {
      return this.inactiveBeneficiaries && this.inactiveBeneficiaries.length > 0;
    }

    get hasInactivePrimaryBeneficiaries (): boolean {
      return this.inactivePrimaryBeneficiaries && this.inactivePrimaryBeneficiaries.length > 0;
    }

    get hasInactiveContingentBeneficiaries (): boolean {
      return this.inactiveContingentBeneficiaries && this.inactiveContingentBeneficiaries.length > 0;
    }
}

